import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import {
  ExecuteWorkflowNode as ExecuteWorkflowNodeInfo,
  isFunctionWorkflowNode,
  Workflow,
} from '@blaze-shared/workflow-domain';

import { WorkflowError } from '../../errors';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';
import { SchemaWithValidationInfo } from '../../validation-context/schema-with-validation-info';
import { validateOrphanedFunctionOutputVariables } from '../_validations/function-node-output-variables';

@WorkflowNode('ExecuteWorkflow')
export class ExecuteWorkflowNode extends BaseWorkflowNode<ExecuteWorkflowNodeInfo> {
  getColumnReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [];
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }

  override validate(
    schemas: Map<string | symbol, SchemaWithValidationInfo>,
    connectors: ConnectorInfo[],
    workflows: Workflow[] = [],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors, workflows);
    if (!isFunctionWorkflowNode(this.node)) {
      return errors;
    }

    return [
      ...errors,
      ...validateOrphanedFunctionOutputVariables(this.workflowId, this.node, workflows),
    ];
  }
}
